import React, { Component } from 'react';
import { Button, Grid, Header, Segment } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

class NotFound extends Component {
    render() {
        return (
            <div>
                {/* eslint-disable-next-line react/jsx-no-undef */}
                <Header as="h1"><FormattedMessage id="common.notFound" /></Header>
                <Grid>
                    <Grid.Column textAlign="center">
                        <Button>404</Button>
                    </Grid.Column>
                </Grid>

            </div>
        );
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/views/NotFound.js